export const TRIAL_CARD_LIST_GROUPING_OPTIONS = [
  { key: 'tier', label: 'Group by Tier' },
  { key: 'phase', label: 'Group by Phase' },
  { key: 'productName', label: 'Group by Compound' },
  { key: 'ragStatus', label: 'Group by RAG' },
];

export const TBD = null;
